import DataTable, { COL_TYPE_ACTIONS, COL_TYPE_DATE } from 'components/DataTable';
import { EntityActionState, selectEntityActions } from 'components/EntityActions';
import { formatType, getPath } from 'utils/entity.utils';
import { useFetchListing, useUserRoleList } from 'hooks/store.hooks';

import ActionAddUserRole from './ActionAddUserRole';
import { ENTITY_USER_ROLE } from 'constants/schemas';
import React from 'react';
import { getGenericId } from 'utils/generic.utils';
import { useNavigate } from 'react-router-dom';
import { userActions } from 'store/entity';

const columns = [
  {
    id: 'role_name',
    label: `${formatType(ENTITY_USER_ROLE)} Name`,
    field: 'name',
    primary: true,
  },
  {
    id: 'created',
    label: 'Date Created',
    field: 'created',
    type: COL_TYPE_DATE,
    secondary: true,
  },
  {
    id: 'actions',
    type: COL_TYPE_ACTIONS,
    showOnHover: true,
    inMenu: true,
    actions: ({ row, state }) => selectEntityActions(state, row.id, ENTITY_USER_ROLE),
  },
];

function UserRoles() {
  const allRoles = useUserRoleList();
  const navigate = useNavigate();
  const { loading } = useFetchListing(userActions.fetchUserRoles);

  return (
    <EntityActionState>
      <DataTable
        rows={allRoles}
        columns={columns}
        actions={(<ActionAddUserRole />)}
        loading={loading}
        onRowClick={(row) => navigate(getPath(getGenericId(row.id, ENTITY_USER_ROLE)))}
        initState={{
          orderBy: 'role_name',
        }}
      />
    </EntityActionState>
  );
}

export default UserRoles;
